<template>
  <div class="admin-layout">
    后台布局
  </div>
</template>
<script>
export default {
  name: 'AdminLayout',
}
</script>
<style lang="scss" scoped>
.admin-layout{}
</style>